import React from 'react';
import ProgressBar from './ProgressBar';
import { scoreColor, formatTime } from './diagnosticHelpers';

const statusMeta = (status, accuracy) => {
  const s = status || (accuracy >= 80 ? 'Strong Area' : accuracy >= 50 ? 'Average' : 'Needs Improvement');
  if (s === 'Strong Area') return { label: 'Strong', tone: '#059669' };
  if (s === 'Average') return { label: 'Developing', tone: '#d97706' };
  return { label: 'Needs Work', tone: '#dc2626' };
};

// Section 4 — Topic Mastery. Sorted strongest → weakest, horizontal bars.
const TopicMasteryList = ({ topics }) => {
  if (!topics || topics.length === 0) {
    return <div className="dxr-card dxr-empty">Topic-level breakdown is not available for this assessment.</div>;
  }

  const sorted = [...topics].sort((a, b) => b.accuracy - a.accuracy);

  return (
    <div className="dxr-card">
      <div className="dxr-topic-list">
        {sorted.map((t, i) => {
          const meta = statusMeta(t.status, t.accuracy);
          return (
            <div className="dxr-topic-row" key={`${t.topic_name}-${i}`}>
              <div className="dxr-topic-info">
                <span className="dxr-topic-name">{t.topic_name}</span>
                {t.category && <span className="dxr-topic-cat">{t.category}</span>}
              </div>
              <div className="dxr-topic-bar">
                <ProgressBar value={t.accuracy} />
              </div>
              <div className="dxr-topic-meta">
                <span className="dxr-topic-acc" style={{ color: scoreColor(t.accuracy) }}>{t.accuracy}%</span>
                <span className="dxr-topic-time">{formatTime(t.avg_time_sec)}/q</span>
                <span className="dxr-topic-status" style={{ color: meta.tone, background: `${meta.tone}14` }}>{meta.label}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TopicMasteryList;
